import ph from './ph';
import id from './id';
import my from './my';
import sg from './sg';

// export default {id,ph,my,sg};//need to remove
const defaultValidation = {id,ph,my,sg};
export default defaultValidation;
